export const LOG_OUT_USER = 'app/LOG_OUT_USER';
export const SET_APP_USER = 'app/SET_APP_USER';
export const SET_APP_DATA = 'app/SET_APP_DATA';
export const APP_HEARTBEAT = 'app/APP_HEARTBEAT';
export const LOAD_PROMOTIONS = 'app/LOAD_PROMOTIONS';
export const LOAD_LOCATIONS = 'app/LOAD_LOCATIONS';
export const UPDATE_PENDING_PROMOTIONS = 'app/UPDATE_PENDING_PROMOTIONS';
export const UPDATE_PENDING_PROMOTIONS_FROM_LIVE = 'app/UPDATE_PENDING_PROMOTIONS_FROM_LIVE';
export const REPLACE_LOCATIONS = 'app/REPLACE_LOCATIONS';